export const URLEndpoints={
    customers:'customers',
    clientContacts:'customers/client-contacts',
    presentation:'presentation',
    generateEmailPresentation:'presentation/generate-presentation',
    presentationComment:'presentation-comment',
    salesOrderComments:'update-product-comment',
    Estimation:'estimation',
    tax:'tax',
    terms:'terms',
    orders:'orders',
    orderItem:'order-item',
    getOrder:'get-order',
    file:'files',
    otherService:'other-service',
    decorators:'decorators',
    purchaseOrder:'purchase-order',
    purchaseOrders:'purchase-orders',
    purchasingReport: 'purchasing-report', 
    reportDefinitions: 'definitions',
    reportRuns: 'runs',         
    proofsList:'proofs-list',
    updateProof:"update-proof",
    uploadProof:'upload-proof',
    shipping:'shipping',
    suppliers:'suppliers',
    address:'address',
    billing:'bill',
    invoices:'Invoices',
    getDesigners:'get-designers'
}